"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityLoadOptions = void 0;
var lodash_1 = require("lodash");
var entityLoadOptions = function (context, entities) {
  return (0, lodash_1.mapValues)(entities, function (entityConfig) {
    return entityConfig.select.loadOptions(context);
  });
};
exports.entityLoadOptions = entityLoadOptions;